import { useState } from "react";
import { MapPin, Navigation, MessageCircle, Check } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { mapsHref, waLink } from "@/lib/format";

export const askLocationText = (name, biz) =>
  `Hi ${(name || "").split(" ")[0]}, this is ${biz || "Nex Fresh"}. To deliver your fresh batter to the right door, please share your Google Maps location: open Google Maps, long-press your home, tap Share and send the link here. Thank you!`;

export const LocationTools = ({ who, saveUrl, method = "post", onSaved, biz, prefix }) => {
  const [link, setLink] = useState("");
  const pinned = who.lat != null;
  const save = async () => {
    try { const r = await api[method](saveUrl, { link }); toast.success("Location pinned"); setLink(""); onSaved(r.data); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-2 rounded-2xl border border-[#E7E2D6] bg-white p-4" data-testid={`${prefix}-location`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className={`inline-flex items-center gap-1 text-sm font-semibold ${pinned ? "text-emerald-700" : "text-rose-600"}`} data-testid={`${prefix}-location-status`}>
          {pinned ? <><Check className="h-4 w-4" />Location pinned</> : <><MapPin className="h-4 w-4" />Location missing</>}
        </span>
        <div className="flex gap-2">
          {pinned && <Button size="sm" variant="outline" asChild><a href={mapsHref(who)} target="_blank" rel="noreferrer" data-testid={`${prefix}-open-maps`}><Navigation className="mr-1 h-4 w-4" />Open in Maps</a></Button>}
          <Button size="sm" variant="outline" asChild><a href={waLink(who.whatsapp || who.phone, askLocationText(who.name, biz))} target="_blank" rel="noreferrer" data-testid={`${prefix}-ask-location`}><MessageCircle className="mr-1 h-4 w-4" />Ask for location</a></Button>
        </div>
      </div>
      <div className="flex gap-2">
        <Input value={link} onChange={(e) => setLink(e.target.value)} placeholder="Paste the Google Maps link they sent" className="h-9 text-sm" data-testid={`${prefix}-maps-link-input`} />
        <Button size="sm" disabled={!link.trim()} onClick={save} className="bg-[#0F382C] hover:bg-[#134E3A]" data-testid={`${prefix}-maps-link-save`}>Pin</Button>
      </div>
    </div>
  );
};
